import * as exEffect from './effect';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        slideUp(duration: number): void;
        slideDown(duration: number): void;
        slideToggle(duration: number): void;
        fadeIn(display?: string): void;
        fadeOut(): void;
        setOpacity(opacity: string): void;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.slideUp = function (duration: number): void {
    exEffect.slideUp(this, duration);
};

HTMLElement.prototype.slideDown = function (duration: number): void {
    exEffect.slideDown(this, duration);
};

HTMLElement.prototype.slideToggle = function (duration: number): void {
    exEffect.slideToggle(this, duration);
};

// ----------------------------------------------------------------------------

HTMLElement.prototype.fadeIn = function (display?: string): void {
    exEffect.fadeIn(this, display);
};

HTMLElement.prototype.fadeOut = function (): void {
    exEffect.fadeOut(this);
};

// ----------------------------------------------------------------------------

HTMLElement.prototype.setOpacity = function (opacity: string): void {
    exEffect.setOpacity(this, opacity);
};
